import { createPortal } from "react-dom";
import PropTypes from "prop-types";

const Portal = ({ id, children, rootClass = "" }) => {
  const elRoot = "window" in global ? document.querySelector("#" + id) : null;

  if (rootClass && elRoot && !elRoot.classList.contains(rootClass)){
    elRoot.classList.add(rootClass);
  }

  return elRoot ? createPortal(children, elRoot) : null;
};

Portal.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
  rootClass: PropTypes.string
};

export default Portal;
